import { api } from "../../services/NetworkBase";

export async function GetVlpUsers() {	
	try {
		let response = await api
		.get(`vlp/users`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}

export async function GetVlpUsersByGroup() {	
	try {
		let response = await api
		.get(`vlp/users/all`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}
export async function GetUniversalSearchData(startDate, endDate) {
  try {
    const res = await api
      .get(
        `vlp/users/search-data?startDate=${startDate || ""}&endDate=${endDate || ""}`
      )
      .json();
    return res;
  } catch (error) {
    throw error;
  }
}


export async function GetVlpUser(userId) {	
	try {
		let response = await api
		.get(`vlp/users/${userId}`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}


export async function UpdateUser(user) {
	try {
	  let response = await api.put(
		"vlp/users",
		{ json: user }
	  );
	  return response;
	} catch (error) {
	  throw error;
	}
  }

  export async function SaveNewUser(user) {
	try {
	  let response = await api.post(
		"vlp/users",
		{ json: user }
	  );
	  return response;
	} catch (error) {
	  throw error;
	}
  }

export async function DeleteVlpUser(userId) {   
    try {        
        let response = await api
        .delete(`vlp/users/${userId}`)
            .json();
        return response;
    } catch (error) {
        throw error;
    }
}

// ================= PERMISSIONS ================= //

export async function GetPermissionsByUser(userId) {
	try {
		let response = await api
			.get(`vlp/users/permissions/user/${userId}`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}

export async function SaveNewPermission(permission) {
	try {
		let response = await api.post(
			"vlp/users/permissions",
			{ json: permission }
		);
		return response;
	} catch (error) {
		throw error;
	}
}

export async function UpdatePermission(permission) {
	try {
		let response = await api.put(
			"vlp/users/permissions",
			{ json: permission }
		);
		return response;
	} catch (error) {
		throw error;
	}
}

export async function DeletePermissionByUser(userId) {
	try {
		let response = await api
			.delete(`vlp/users/permissions/user/${userId}`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}

export async function DeletePermissionById(permissionId) {
	try {
		let response = await api
			.delete(`vlp/users/permissions/${permissionId}`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}

// ================= ACCESS GROUPS ================= //

export async function GetAllSecurityGroups() {
	try {
		let response = await api
			.get(`vlp/users/security-groups`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}

export async function GetUserGroups(userId) {
	try {
		let response = await api
			.get(`vlp/users/${encodeURIComponent(userId)}/groups`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}

export async function AssignSecurityGroup(userId, securityGroup) {
	try {
		let response = await api.post(
			`vlp/users/${encodeURIComponent(userId)}/groups`,
			{ json: { userId, securityGroup } }
		).json();
		return response;
	} catch (error) {
		throw error;
	}
}

export async function UnassignSecurityGroup(userId, securityGroup) {
	try {
		let response = await api
			.delete(`vlp/users/${encodeURIComponent(userId)}/groups`, {
				json: { userId, securityGroup },
			})
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}

